import React from 'react';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { useTranslations } from '@unisporkal/localization';
import styles from './DownloadSizePreview.module.scss';
import Checkmark from '../../../icons/CheckMark.svg?icon';

interface SizeObject {
  width: string;
  height: string;
  dpi: string;
}

interface DownloadSizePreviewProps {
  sizeObject: SizeObject;
  isModified?: boolean;
  fileType?: string;
}

const DownloadSizePreview = ({
  sizeObject,
  isModified = false,
  fileType = 'JPG',
}: DownloadSizePreviewProps) => {
  const t = useTranslations();

  const imageText = isModified
    ? t('one_modified_image')
    : t('one_original_image');

  const dpiText = isModified ? '' : ` - ${sizeObject.dpi} dpi`;

  return (
    <div
      className={styles.downloadSizeAndSelector}
      data-testid="download-size-and-selector"
    >
      <Checkmark className={styles.checkmarkIcon} />
      <div className={styles.textContainer}>
        <Typography
          component={TypographyComponentEnum.DIV}
          variant={TypographyVariant.body.large}
          className={styles.modifiedImageText}
        >
          {imageText} ({fileType === 'JPEG' ? 'JPG' : fileType})
        </Typography>
        <Typography
          component={TypographyComponentEnum.SPAN}
          variant={TypographyVariant.body.small}
          className={styles.sizeText}
        >
          {`${sizeObject.width} x ${sizeObject.height} px${dpiText}`}
        </Typography>
      </div>
    </div>
  );
};

export default DownloadSizePreview;
